import { Reveal, SectionHeading } from "./Reveal";
import { Brain, Compass, Wind, Sparkles } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: Compass,
    testId: "manifesto-card-psychologie",
    title: "Psychologie du travail",
    text: "Licence en psychologie du travail, Master 2 en gestion des ressources humaines : vingt ans à lire les dynamiques humaines des organisations avant de les transformer.",
  },
  {
    num: "02",
    icon: Brain,
    testId: "manifesto-card-neuroscience",
    title: "Neurosciences & haut potentiel",
    text: "HPI/HPE elle-même, Frédérique décrypte de l'intérieur les modes de pensée atypiques — cette intensité qui fait la force des dirigeants, et parfois leur épuisement.",
  },
  {
    num: "03",
    icon: Wind,
    testId: "manifesto-card-outils",
    title: "Sophrologie, hypnose & EMDR",
    text: "Des outils précis — jamais une étiquette. Sophrologie, hypnose, EMDR, EFT : une boîte à outils mobilisée uniquement au service de votre objectif.",
  },
  {
    num: "04",
    icon: Sparkles,
    testId: "manifesto-card-experience",
    title: "L'expérience vécue",
    text: "Un parcours personnel au cœur de la neurodiversité, des échelons gravis en entreprise : une compréhension incarnée de ce que vous traversez, sans jargon ni distance.",
  },
];

export default function Manifesto() {
  return (
    <section id="approche" data-testid="manifesto-section" className="relative py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          overtitle="Le manifeste — 04 chapitres"
          title={<>Une alchimie rare : la science, l'outil,<br className="hidden sm:block" /> et le vécu.</>}
        />
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-400 leading-relaxed">
            Ce que je vous propose n'est pas une méthode figée, mais l'alliance de connaissances
            théoriques solides et d'une expérience profondément vécue.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-5">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.12} className={i % 2 === 1 ? "md:translate-y-10" : ""}>
              <article
                data-testid={c.testId}
                className="group relative h-full rounded-2xl border border-[#D4AF37]/15 bg-[#111C33]/60 p-8 lg:p-10 overflow-hidden transition-all duration-500 hover:border-[#D4AF37]/45 hover:bg-[#111C33]"
              >
                <div className="absolute -right-6 -top-8 font-mono-accent text-[7rem] leading-none text-[#D4AF37]/[0.06] transition-all duration-700 group-hover:text-[#D4AF37]/[0.14] group-hover:-translate-y-1 select-none">
                  {c.num}
                </div>
                <c.icon className="text-[#D4AF37]" size={26} strokeWidth={1.5} />
                <p className="font-mono-accent mt-6 text-[10px] uppercase tracking-[0.3em] text-slate-500">
                  Chapitre {c.num}
                </p>
                <h3 className="font-serif-display mt-2 text-2xl text-white">{c.title}</h3>
                <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{c.text}</p>
                <div className="gold-hairline absolute bottom-0 left-0 h-px w-0 transition-all duration-700 group-hover:w-full" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
